/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2020 - 2021
///                            Coyote Logistics L.L.C.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

import React from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";

import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import List from "@material-ui/core/List";

import Note from "./Note";
import CircularProgress from "@material-ui/core/CircularProgress";
import types from '../../helpers/types';
import {
  isShipper,
  isShipperManager,
  isAdministrator,
} from "../../helpers/goTrackUserUtils";

const StyledCard = styled(Card)`
  width: 100%;
  margin-top: 4px;
  min-height: 250px;
`;

const StyledList = styled(List)`
  max-height: 300px;
  overflow: auto;
`;

const StyledCircularProgress = styled(CircularProgress)`
  position: relative;
  left: calc(50% - 20px);
  margin-top: 100px;
`;

const NotesPanel = ({ notes, isLoading }) => {
  const { goTrackUser } = useSelector((state) => state.goTrackUser);

  const displayNoteIcon =
    isShipper(goTrackUser.roles) ||
    isShipperManager(goTrackUser.roles) ||
    isAdministrator(goTrackUser.roles);

  return (
    <StyledCard variant="outlined">
      <CardContent>
        {isLoading ? (
          <StyledCircularProgress />
        ) : (
          <StyledList component="ol" disablePadding>
            {notes.map((note) => (
              <Note
                key={note.createTime}
                note={note}
                displayNoteIcon={displayNoteIcon}
              />
            ))}
          </StyledList>
        )}
      </CardContent>
    </StyledCard>
  );
};

export default NotesPanel;
